<template>
  <div class="seeContract">
    <van-sticky>
      <div
        class="seeContractNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">查看合同</span>
        <img
          class="navRight"
          @click="copy()"
          id="copy"
          src="./../../../assets/decoration/copy.png"
        />
      </div>
    </van-sticky>
    <div class="contentBox">
      <div id="contidract" :style="contidractStyle" ref="contidract">
        <div :style="pdfStyle" ref="pdfbox">
          <pdf
            v-for="i in numPages"
            :key="i"
            :src="pdfSrc"
            :page="i"
            ref="pdfs"
            @loaded="pdfLoaded(i)"
            :style="{ width: '100%' }"
          >
          </pdf>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      isiOSX: false,
      pdfStyle: { "transform-origin": "left top" },
      contidractStyle: { "background-color": "#E3E3E3", height: "100%" },
      numPages: undefined,
      pdfSrc: "",
      data:{}
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    setTimeout(() => {
      this.onLoad();
    }, 200);
  },
  mounted() {},
  components: {
    pdf,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      this.$api
        .post("decoration/member/contract/agent/show", {
          contract_id: this.$route.query.contract_id,
        })
        .then((res) => {
          this.data = res;
          if (res.sign_file_url) {
            this.pdfSrc =
              location.protocol + "//" + res.sign_file_url.split("//")[1];
          }
          if (this.pdfSrc) {
            this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
            this.pdfSrc.promise.then((pdf) => {
              this.numPages = pdf.numPages;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    copy() {
      var clipboard = new Clipboard("#copy", {
        text: () => {
          return this.data.sign_file_url;
        },
      });
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
    async pdfLoaded(i) {
      if (this.numPages !== i) {
        return;
      }
    },
  },
};
</script>
<style lang="less">
.seeContract {
  height: 100%;
  background: #f2f2f2;
  .seeContractNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
    .navRight {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 16px;
      bottom: 10px;
    }
  }
}
</style>